import styled from 'styled-components';
import CustomSmallButton from '../../../../../../../../../../../components/button/CustomSmallButton';
import CustomBlockButton from '../../../../../../../../../../../components/button/CustomBlockButton';
import { LuCheck, LuChevronLeft } from 'react-icons/lu';

const StyledContainer = styled.div`
    margin-top: 10px;

    h2{
        font-size: 18px;
        font-weight: bold;
    }

    button{
        &.active{
            background: var(--greenColor1-light);
            color: var(--greenColor1)
        }

        &.disabled{
            background: var(--redColor2-light);
            color: var(--redColor2);
        }
        border-color: #d0d0d0;
    }

    .footer{
        display: flex;
        gap: 10px;
        margin-top: 20px;
    }
`;

export function FragmentMergeLocationSelectStep({
    selectedRackLocation,
    mergingLocationActive,
    setMergingLocationActive,
    onPrevStepToItemsCheck,
    onSubmitReflection
}) {
    return (
        <>
            <StyledContainer>
                <h2>병렬 로케이션 지정</h2>
                <div style={{ marginTop: '20px' }}>
                    {mergingLocationActive ?
                        <div>
                            <CustomSmallButton
                                type='button'
                                onClick={() => setMergingLocationActive(false)}
                                className='active'
                            >
                                사용 {getMergingLocationAddress(selectedRackLocation?.address)}
                            </CustomSmallButton>
                        </div>
                        :
                        <div>
                            <CustomSmallButton
                                type='button'
                                className='disabled'
                                onClick={() => setMergingLocationActive(true)}
                            >사용안함</CustomSmallButton>
                        </div>
                    }
                </div>
                <div className='footer'>
                    <CustomBlockButton
                        type='button'
                        onClick={() => onPrevStepToItemsCheck()}
                    >
                        <div className='flex items-center gap-2'>
                            <LuChevronLeft /> <span>이전단계</span>
                        </div>
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        onClick={() => { onSubmitReflection(); }}
                        style={{ background: '#333', color: '#fff' }}
                    >
                        <div className='flex items-center gap-2'>
                            <LuCheck /> <span>로케이션반영</span>
                        </div>
                    </CustomBlockButton>
                </div>
            </StyledContainer>
        </>
    );
}

// address의 형식은 'Z-{Rack}-{Bay}-{Level}-{Position}'인데 position값만 01 -> 02, 02 -> 01로 변경해준다.
function getMergingLocationAddress(address) {
    const addressSplit = address?.split('-');
    if (addressSplit.length < 5) return address; // 잘못된 형식일 경우 원래 주소 반환

    const rack = addressSplit[1];
    const bay = addressSplit[2];
    const level = addressSplit[3];
    const position = addressSplit[4];

    // position 값이 01이면 02로, 02면 01로 변경
    const newPosition = position === '01' ? '02' : '01';

    return `Z-${rack}-${bay}-${level}-${newPosition}`;
}